/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react"
import StakeInput from "components/setStake/StakeInput"
import { StakeWrapper } from "components/gameBoard/GameBoardStyled"

const SetStake = ({
  SFXS,
  handleStake,
  handleAbove,
  handleNotification,
  gameInfo,
  bankerStake,
  playerStake,
  tieStake,
  handlePlayerStake,
  handleBankerStake,
  handleTieStake,
  handleCurrentStake,
  handleCurrentName,
  isZero,
  isGameActive,
}: any) => {
  const CONTENT = [
    {
      name: "player",
      stake: playerStake,
      handler: handlePlayerStake,
    },
    { name: "tie (8 TO 1)", stake: tieStake, handler: handleTieStake },
    { name: "banker", stake: bankerStake, handler: handleBankerStake },
  ]

  return (
    <StakeWrapper isGameActive={isGameActive}>
      {CONTENT.map((name, id) => (
        <StakeInput
          key={id}
          name={name.name}
          stake={name.stake}
          handleStake={handleStake}
          handleThisStake={name.handler}
          handleAbove={handleAbove}
          SFXS={SFXS}
          handleNotification={handleNotification}
          gameInfo={gameInfo}
          handleCurrentStake={handleCurrentStake}
          handleCurrentName={handleCurrentName}
          isZero={isZero}
        />
      ))}
    </StakeWrapper>
  )
}
export default SetStake
